import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import _ from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useDevicesByType } from 'app/agriculture/queries/devices/useDevicesByType';

interface Props {
    label?: string;
    initialWeatherStationId: string | null;
    onChange: (weatherStationId: string | null) => void;
}

export function WeatherStationSelector({
    onChange,
    initialWeatherStationId,
    label = 'Weather Station',
}: Props) {
    const weatherStations = useDevicesByType('Weather Station');
    const options = useMemo(() => {
        const options = [...weatherStations].map(([id, { name }]) => ({ id, label: name }));
        return _.sortBy(options, 'label');
    }, [weatherStations]);
    const [value, setValue] = useState<{ label: string; id: string } | null>(
        () => options.find(({ id }) => id === initialWeatherStationId) ?? null,
    );

    const handleChange = useCallback(
        (option: (typeof options)[number] | null) => {
            onChange(option?.id ?? null);
            setValue(option);
        },
        [onChange],
    );

    return (
        <Autocomplete
            disabled={options.length <= 1}
            id="ag-weather-station-autocomplete"
            options={options}
            fullWidth
            autoComplete
            value={value}
            noOptionsText="No Stations"
            isOptionEqualToValue={(option, value) => option.id === value.id}
            onChange={(e, value) => {
                handleChange(value);
            }}
            renderInput={(params) => <TextField {...params} label={label} fullWidth />}
        />
    );
}
